import { productImageStyles } from "@insite/content-library/Components/ProductImage";
import { css } from "styled-components";



productImageStyles.linkWrappingImage = {
    css: css`
        max-height: 150px;
        height: 137px;
        text-align: center;
        align-items: center;
        justify-content: center;

    `
}

productImageStyles.img = {
    css: css`
        height: auto;
        width: 100%;
        max-height: 135px;
        max-width: 160px;
    `
}